import { queryClient } from '../../../App'
import { notifySuccess } from '../../../services/ToastifyService/ToastifyService'
import { closeModalFn } from '../../../utils/controllers/ModalController'

type OnSuccessOptions = {
  withReportData?: boolean
  withReportTable?: boolean
  withAddToReport?: boolean
  notification?: string
  withCreateReportTable?: boolean
  withServiceTable?: boolean
}

export const handleOnSuccess = (
  options: OnSuccessOptions,
  callback?: () => void,
) => {
  const {
    withReportData,
    withCreateReportTable,
    withReportTable,
    notification,
    withAddToReport,
    withServiceTable,
  } = options

  queryClient.invalidateQueries({
    queryKey: ['single-service-report-table'],
  })

  withReportData &&
    queryClient.invalidateQueries({
      queryKey: ['get-single-service-report-data'],
    })

  withReportTable &&
    queryClient.invalidateQueries({
      queryKey: ['service-reports-table'],
    })

  withAddToReport &&
    queryClient.invalidateQueries({
      queryKey: ['add-requests-to-service-report-table'],
    })

  if (withServiceTable) {
    queryClient.invalidateQueries({
      queryKey: ['service-table'],
    })
  }

  if (withCreateReportTable) {
    queryClient.invalidateQueries({
      queryKey: ['create-service-report-table'],
    })

    queryClient.invalidateQueries({
      queryKey: ['get-service-history'],
    })

    queryClient.invalidateQueries({
      queryKey: ['get-suits-ids-for-create'],
    })
  }

  callback && callback()

  notification && notifySuccess(notification)

  closeModalFn['progress-backdrop']?.()
}

export const onError = () => {
  closeModalFn['progress-backdrop']?.()
}
